import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import './Subscription.css';

const DEFAULT_VERIFY_RECAPTCHA_URL =
  'https://us-central1-alegra-club.cloudfunctions.net/verifyReCaptcha';

/** ID de documento estable para reglas Firestore sin permitir list público. */
function subscriptionDocumentId(email) {
  return email
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9@._-]+/g, '_')
    .slice(0, 800);
}

const Subscription = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyRecaptchaUrl =
    process.env.REACT_APP_VERIFY_RECAPTCHA_URL || DEFAULT_VERIFY_RECAPTCHA_URL;

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert('Por favor, ingresa tu correo electrónico.');
      return;
    }

    let recaptchaToken = null;
    if (executeRecaptcha) {
      try {
        recaptchaToken = await executeRecaptcha('subscribe');
      } catch (error) {
        console.error('Error ejecutando reCAPTCHA:', error);
        alert('Error de reCAPTCHA, por favor intente nuevamente.');
        return;
      }
    } else {
      alert('reCAPTCHA no está listo. Recarga la página e intente nuevamente.');
      return;
    }

    setIsLoading(true);

    try {
      const subId = subscriptionDocumentId(email);
      const existing = await getDoc(doc(db, 'Subscriptions', subId));
      if (existing.exists()) {
        alert('Este correo electrónico ya está suscrito.');
        setIsLoading(false);
        return;
      }

      const response = verifyRecaptchaUrl
        ? await fetch(verifyRecaptchaUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: recaptchaToken })
          })
        : { ok: false };

      const result = response.ok ? await response.json() : { success: false };

      if (result.success) {
        const now = new Date();
        const subscriptionData = {
          email: email.trim(),
          createdAt: now,
          timestamp: now,
          recaptchaToken,
          emailSent: false
        };

        await setDoc(doc(db, 'Subscriptions', subId), subscriptionData);
        console.log('Subscription successful:', { email: email.trim() });

        setEmail('');
        alert('¡Gracias por suscribirte! Revisa tu correo electrónico.');
      } else {
        alert('Error de verificación reCAPTCHA. Por favor, intente nuevamente.');
      }
    } catch (error) {
      console.error('Error al suscribirse:', error);
      alert('Hubo un error al suscribirse. Por favor, intente nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="subscription-form">
      <h2>Suscríbete</h2>
      <form onSubmit={handleSubscribe}>
        <div className="form-group">
          <label className="label" htmlFor="subscription-email">
            Promos, novedades y ofertas exclusivas en tu correo
          </label>
          <input
            type="email"
            placeholder="tu@email.com"
            id="subscription-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="subscription-input"
            disabled={isLoading}
          />
        </div>
        <button type="submit" className="subscription-button" disabled={isLoading}>
          {isLoading ? 'Enviando...' : '¡Quiero suscribirme!'}
        </button>
      </form>
    </div>
  );
};

export default Subscription;
